import { jsx } from "react/jsx-runtime";
import { PromptLoginWidget } from "@brandclub/bc-widgets";
import { useConciergeContext } from "../../ConciergeContextProvider.js";
function PromptLoginPart({ reason, onSignIn }) {
  const { isSignedIn, onSignIn: contextOnSignIn } = useConciergeContext();
  if (isSignedIn) return null;
  return /* @__PURE__ */ jsx(
    PromptLoginWidget,
    {
      widgetId: "concierge-prompt-login",
      title: reason || "Sign in required",
      description: "Sign in to access your order history and personalized features",
      buttonText: "Sign In",
      onSignIn: onSignIn ?? contextOnSignIn
    }
  );
}
export {
  PromptLoginPart
};
//# sourceMappingURL=PromptLoginPart.js.map
